import { useEffect, useState } from 'react'

const STEP = 6

const usePagination = ({ students }) => {
    const [studentsToDisplay, setStudentsToDisplay] = useState([])
    const [sliceBy, setSliceBy] = useState([0, STEP])
    const [currentPage, setCurrentPage] = useState(1)

    const totalPages = (() => {
        const incrementer = students?.length % STEP === 0 ? 0 : 1
        return parseInt(students?.length / STEP) + incrementer
    })()

    useEffect(() => {
        const slicedStudents = students?.slice(...sliceBy)
        setStudentsToDisplay([...slicedStudents])
    }, [sliceBy, students])

    const up = () => {
        const [start, end] = sliceBy
        const newStart = start - STEP
        const newEnd = end - STEP

        if (newStart < 0 && newEnd < STEP) return

        const newSliceBy = [newStart, newEnd]
        setSliceBy(newSliceBy)
        setCurrentPage(currentPage => currentPage - 1)
    }

    const down = () => {
        const [start, end] = sliceBy
        const newStart = start + STEP
        const newEnd = end + STEP

        if (newStart >= students.length) return

        const newSliceBy = [newStart, newEnd]
        setSliceBy(newSliceBy)
        setCurrentPage(currentPage => currentPage + 1)
    }

    return {
        up,
        down,
        upDisabled: sliceBy[0] - STEP < 0 && sliceBy[1] - STEP < STEP,
        downDisabled: sliceBy[0] + STEP >= students.length,
        studentsToDisplay,
        totalPages,
        currentPage,
    }
}

export default usePagination
